import axios from "axios";

const FilterForCamera = async () => {
  let token = localStorage.getItem("token");
  let { data } = await axios(
    `https://godrej.app-assertai.com:5000/Filters/cameraFilter`,
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};
const DropDownValues = async () => {
  let token = localStorage.getItem("token");
  let { data } = await axios(
    `https://godrej.app-assertai.com:5000/Table/alert-location-camera-users`,
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export { FilterForCamera, DropDownValues };
